import { useTeams } from '@/app/hooks/useTeams'
import { BasicAsyncSelect } from '@/view/components/BasicAsyncSelect'
import { useFormContext } from 'react-hook-form'
import { FilterFormData } from './FilterReports'
import { MultiValue } from 'react-select'
import { OptionType } from '@/app/utils/optionSelectType'

interface TeamProps {
  opt: MultiValue<OptionType>
  setOpt: React.Dispatch<React.SetStateAction<MultiValue<OptionType>>>
}

export default function Teams({ opt, setOpt }: TeamProps) {
  const {
    setValue,
    formState: { errors },
  } = useFormContext<FilterFormData>()

  const {
    data: fullTeamData,
    fetchNextPage: fetchTeam,
    hasNextPage: hasTeam,
    isFetching: isFetchingTeam,
    isLoading: isLoadingTeam,
    setParams: setParamsTeam,
  } = useTeams()

  const teamsData = fullTeamData?.pages.flatMap((page) =>
    page.teams.map((team) => ({
      value: team._id,
      label: team.name,
    })),
  )

  const handleLoadMoreTeam = () => {
    if (hasTeam && !isFetchingTeam) {
      fetchTeam()
    }
  }

  const handleSelectTeam = (selectedTeamOptions: MultiValue<OptionType>) => {
    const value = selectedTeamOptions?.map(({ value }) => value) || undefined
    setValue('teamIds', value as unknown as string)
    setOpt(selectedTeamOptions)
  }

  return (
    <div className="space-y-2">
      <h3 className="font-medium text-black04">Equipes</h3>
      <BasicAsyncSelect
        data={teamsData}
        handleSelectedValue={handleSelectTeam}
        isLoading={isFetchingTeam || isLoadingTeam}
        onMenuScrollToBottom={handleLoadMoreTeam}
        placeholder="Selecione a(s) equipe(s)"
        setParams={setParamsTeam}
        value={opt}
        inputError={errors.teamIds?.message}
      />
    </div>
  )
}
